import { GET_TRANSLATIONS_REQUEST } from '../../Constants/reduxRequestKeys';

export function getTranslations() {
  return {
    type: GET_TRANSLATIONS_REQUEST,
    payload: {},
  };
};
